import React, { Fragment } from 'react';
import './home.component.css';
import HeaderV3 from '../../../../components/HeaderV3/headerV3.component';
import FooterSection from '../../../../components/FooterSection/footersection.component';
import Hero from '../components/Hero/Hero';
import WhyOrbix from '../components/WhyOrbix/WhyOrbix';
import MeetAITeam from './home-components/MeetAITeam/MeetAITeam';
import OrbixOculo from '../components/OrbixOculo/OrbixOculo';
import TalkToProject from '../components/TalkToProject/TalkToProject';
import RTAgent from '../components/RTAgent/RTAgent';
import Analytics from '../components/Analytics/Analytics';
import RealtimeOversight from '../components/RealtimeOversight/RealtimeOversight';
import OnePlatform from '../components/OnePlatform/OnePlatform';
import CTA from '../components/CTA/CTA';
import Testimonials from '../components/Testimonials/Testimonials';

function HomeV3() {
  return (
    <Fragment>
      {/* Main */}
      <main className="page-wrapper-v3">
        {/* Existing Header - shared across all pages */}
        <HeaderV3 />
        
        {/* Hero Section - V3 Design */}
        <Hero />
        
        {/* Why Orbix? - Problem & Solution Section */}
        <WhyOrbix />
        
        {/* Meet Your AI Compliance Team Section*/}
        <MeetAITeam /> 
        
        {/* Orbix Oculo - VT Section */}
        <OrbixOculo />
        
        {/* Talk to Your Project - Conversational Interface */}
        <TalkToProject />
        
        {/* RT Agent - Defect Detection & Fraud Prevention */}
        <RTAgent />
        
        {/* Analytics & Project Intelligence */}
        <Analytics />
        
        {/* Real-Time Oversight & Seamless Collaboration */}
        <RealtimeOversight />
        
        {/* One Platform */}
        <OnePlatform /> 
        
        {/* CTA - Call to Action */}
        <CTA />
        
        {/* Testimonials - Client Reviews */}
        <Testimonials />

        <FooterSection />
      </main>
      
      {/* Existing Footer - shared across all pages */}
    
    </Fragment>
  );
}

export default HomeV3;

